import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import notify from "devextreme/ui/notify";
import {
    IOcbFileTransferLog,
    OcbFileTransferLogTypes,
    FileTransfersService,
    UserService
} from "../../core";

@Component({
    selector: 'app-file-transfer-log',
    templateUrl: './file-transfer-log-popup.component.html',
    styleUrls: ['./file-transfer-log-popup.component.scss']
})
export class FileTransferLogComponent implements AfterViewInit {
    @Input() public log?: IOcbFileTransferLog;
    @Input() public logId?: string;
     
    public visible: boolean = false;

    private displayedLog?: IOcbFileTransferLog;
    private isProgressBarVisible: boolean = false;
    private logsTypesLabels: any[];

    constructor(private logsService: FileTransfersService, private translateService: TranslateService, private userService: UserService) {
        this.displayLogDate = this.displayLogDate.bind(this);
        this.displayLogType = this.displayLogType.bind(this);
    }

    public ngAfterViewInit() {
        this.translateService.get('fileTransferLogTypes').subscribe(logTypes => {
            this.logsTypesLabels = logTypes;
        });
    }

    public onHidden() { this.displayedLog = null; }

    public onShown() {
        if (this.log) this.displayedLog = this.log;
        else if (this.logId) {
            this.isProgressBarVisible = true;
            this.logsService.getLog(this.logId).subscribe({
                next: (log) => {
                    this.displayedLog = log;
                    this.isProgressBarVisible = false;
                },
                error: (err) => this.handleError(err)
            });
        }
        else this.isProgressBarVisible = false;
    }


    public displayLogDate(log): string { return log?.transferDate ? this.displayDate(log.transferDate).toLocaleString(this.getCurrentLocale()) : ''; }

    public displayLogType(log): string { return log?.logType ? this.logsTypesLabels[OcbFileTransferLogTypes[log.logType]] : ''; }


    private displayDate(dateValue): Date { return new Date(dateValue + 'Z'); }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) {
                message = error.error.message;
            } else if (error.error.hasOwnProperty('name')) {
                message = error.error.name;
            } else {
                message = error.error;
            }
        } else {
            message = error;
        }

        notify(message, 'error', 3000);
    }

    private getCurrentLocale(): string {
        let currentLocale = 'en-US';
        switch (this.userService.language) {
            case 'en': currentLocale = 'en-US'; break;
            case 'fr': currentLocale = 'fr-FR'; break;
        }
        return currentLocale;
    }
}
